import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "Dateien", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Unterlagen", -1)

import ApiDownload from '@/components/ApiDownload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Downloads',
  props: {
  dateien: {
    type: Array<any>,
    required: false,
  },
  unterlagen: {
    type: Array<any>,
    required: false,
  },
},
  setup(__props, { expose: __expose }) {



__expose({
  ApiDownload,
});


return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    ((__props.dateien && __props.dateien?.length)||(__props.unterlagen && __props.unterlagen?.length))
      ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
          key: 0,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            (__props.dateien && __props.dateien?.length)
              ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, null, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dateien, (file) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: file.DownloadToken
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(ApiDownload, {
                                    title: file.Dateiname.replaceAll('_', ' '),
                                    token: file.DownloadToken,
                                    "file-name": file.Dateiname
                                  }, null, 8, ["title", "token", "file-name"])
                                ], undefined, true),
                                _: 2
                              }, 1024))
                            }), 128))
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.unterlagen && __props.unterlagen?.length)
              ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.unterlagen, (item) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: item.Bezeichnung
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "mb-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.Bezeichnung), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Seiten, (page) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          cols: "6",
                                          key: page
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(ApiDownload, {
                                              key: page.Seite,
                                              title: `Seite ${page.Seite}`,
                                              token: page.DownloadToken,
                                              "file-name": `${page.Seite.toString()}.jpg`
                                            }, null, 8, ["title", "token", "file-name"]))
                                          ], undefined, true),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ], undefined, true),
                                    _: 2
                                  }, 1024)
                                ], undefined, true),
                                _: 2
                              }, 1024))
                            }), 128))
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})